module.exports = {
  112: "28rem", // 448px
  128: "32rem", // 512px
};
